<template>
  <div>
    <div class="search__form">
      <span class="search__title">{{ title }}</span>

      <div class="search__inputs">
        <input
          ref="inputQuery"
          v-model="query"
          type="text"
          class="input"
          placeholder="Smart Media Insights"
          @keyup="doSearch"
        >
        <span class="p-1 text-argus-primary hover:text-argus-accent transition-colors cursor-pointer">
          <ag-icon
            icon="search"
            size="23"
          />
        </span>
      </div>

      <span
        class="search__close"
        @click="$emit('close-menu')"
      >
        <ag-icon
          icon="x"
          size="28"
        />
      </span>
    </div>

    <div class="search__results">
      <span class="search__results-left" />

      <!-- Loading -->
      <div
        v-if="isLoading"
        class="search__results-loading"
      >
        <ag-loading />
      </div>
      <!-- ./Loading -->

      <!-- No Results -->
      <div v-else-if="data !== null && data.length === 0">
        {{ noResults }}
      </div>
      <!-- ./No Results -->

      <!-- Search Results -->
      <div
        v-else
        class="search__list"
      >
        <div
          v-for="result in data"
          :key="result.id"
          class="search-item"
        >
          <a
            :href="result.url"
            class="search__list-item"
          >
            <p
              class="search__item-title"
              v-html="result.title"
            ></p>
            <div class="search__item-content">
              <p>
                {{ result.search_excerpt }}
              </p>
              <button
                type="button"
                class="button"
              >
                {{ 'Go' }}
              </button>
            </div>
          </a>
        </div>
      </div>
      <!-- ./Search Results -->

      <span class="search__results-right" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import mixinAxios from '../mixin/axios'
import { debounce } from '../utils/helper'

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    noResults: {
      type: String,
      required: true,
    }
  },
  mixins: [mixinAxios],
  data() {
    return {
      query: '',
    }
  },
  mounted() {
    this.$refs.inputQuery.focus()
  },
  methods: {
    doSearch: debounce(function () {
      if (this.query) {
        this.callAxios({ url: 'search', params: { search: this.query, per_page: 9 } })
      }
    }),
  },
})
</script>

<style lang="scss" scoped>
@import '../../scss/abstracts/colors';
@import '../../scss/abstracts/variables';

.search-item {
  margin-top: 28px;
  margin-left: 48px;
  width: calc( 100% / 3 - 48px);
}

@media only screen and (max-width: 768px) {
  .search-item {
    width: calc( 100% / 2 - 48px);
  }
}

@media only screen and (max-width: 425px) {
  .search-item {
    width: calc( 100% / 1 - 48px);
  }
}

</style>
